module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "上传视频",
      "width": "45%",
      "center": true,
      "visible": _vm.addVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.addVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "add-body"
  }, [_c('el-form', {
    ref: "submitForm",
    staticClass: "add-body-form",
    attrs: {
      "model": _vm.submitData,
      "rules": _vm.validatorRules,
      "label-width": "130px"
    }
  }, [_c('div', {
    staticClass: "add-body-div"
  }, [_c('div', {
    staticClass: "add-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "视频标题",
      "prop": "videoTitle",
      "size": "medium"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写-视频标题",
      "type": "textarea",
      "maxlength": "200",
      "show-word-limit": "",
      "rows": "2"
    },
    model: {
      value: (_vm.submitData.videoTitle),
      callback: function($$v) {
        _vm.$set(_vm.submitData, "videoTitle", $$v)
      },
      expression: "submitData.videoTitle"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "add-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "视频简介",
      "prop": "videoText",
      "size": "medium"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写-视频简介",
      "type": "textarea",
      "maxlength": "200",
      "show-word-limit": "",
      "rows": "2"
    },
    model: {
      value: (_vm.submitData.videoText),
      callback: function($$v) {
        _vm.$set(_vm.submitData, "videoText", $$v)
      },
      expression: "submitData.videoText"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-divider', {
    attrs: {
      "content-position": "center"
    }
  }, [_vm._v("上传视频")]), _vm._v(" "), _c('div', {
    staticClass: "add-body-div"
  }, [_c('div', {
    staticClass: "add-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "视频信息:"
    }
  }, [_c('div', {
    staticClass: "upload-item-view"
  }, [_c('UploadVideo', {
    ref: "videoUploader",
    attrs: {
      "headers": _vm.uploadHeaders,
      "uploadApi": _vm.uploadUrl,
      "fileList": _vm.videoList,
      "buttonText": _vm.buttonText,
      "upLoadParams": {}
    },
    on: {
      "onSuccess": _vm.onVideoSuccess,
      "handleRemove": _vm.handleVideoRemove
    }
  })], 1)])], 1)]), _vm._v(" "), _c('el-divider', {
    attrs: {
      "content-position": "center"
    }
  }, [_vm._v("上传视频封面图片")]), _vm._v(" "), _c('div', {
    staticClass: "add-body-div"
  }, [_c('div', {
    staticClass: "add-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "封面图:"
    }
  }, [_c('div', {
    staticClass: "upload-item-view"
  }, [_c('UploadImg', {
    ref: "uploadImgCover",
    staticClass: "upload-item",
    attrs: {
      "uploadApi": _vm.uploadUrl,
      "fileList": _vm.submitData.faceUrlList,
      "limit": 1,
      "headers": _vm.uploadHeaders
    },
    on: {
      "subBack": _vm.uploadFaceImgSuccess,
      "handleFileDelete": _vm.uploadFaceImgDelete
    }
  })], 1)])], 1)])], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("提 交")])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-71f13a75", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71f13a75"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/main/VideoUploadView.vue
// module id = 1303
// module chunks = 1